import { CircularProgress } from '@mui/material'
import {
	GET_FM_PARTNER_LIST_FOLLOWERS_FOLLOWERS,
	getFMPartnerListFollowers
} from 'api'
import { BoxPartners, Button } from 'components'
import { FMPartnerListFollowersItem, ShareFMPartnerProps } from 'interfaces'
import React, { useEffect, useMemo, useState } from 'react'
import { useInfiniteQuery } from 'react-query'
import { useInView } from 'react-intersection-observer'
import Cookies from 'universal-cookie'

export const ShareFMPartner: React.FC<ShareFMPartnerProps> = ({
	totalData,
	onClickClose,
	setTotalData,
	setSlideAudience,
	setShareFMPartner
}): JSX.Element => {
	const cookies = new Cookies()
	const userId = cookies.get('userId')
	const organizationId = cookies.get('organization_id')
	const { ref, inView } = useInView()

	const [FMPartnersSelected, setFMPartnersSelected] = useState<number[]>(() => [
		...totalData.delivery_enhancements.audience.partner_lists
	])
	const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
		useInfiniteQuery(
			[GET_FM_PARTNER_LIST_FOLLOWERS_FOLLOWERS, userId, organizationId],
			({ pageParam = 1 }) =>
				getFMPartnerListFollowers(organizationId, pageParam),
			{
				getPreviousPageParam: firstPage =>
					firstPage?.page ? firstPage.page : undefined,
				getNextPageParam: lastPage =>
					lastPage && lastPage.page < lastPage.pages
						? lastPage.page + 1
						: undefined
			}
		)

	useEffect(() => {
		if (inView && hasNextPage) fetchNextPage()
	}, [inView])

	const listPartners = useMemo(
		() => data?.pages.flatMap(page => page?.items ?? []) ?? [],
		[data]
	)

	const handleClickPartner = (partner: FMPartnerListFollowersItem): void => {
		if (FMPartnersSelected.includes(partner.id)) {
			setFMPartnersSelected(
				FMPartnersSelected.filter(item => item !== partner.id)
			)
		} else {
			setFMPartnersSelected([...FMPartnersSelected, partner.id])
		}
	}

	const onSubmit = (): void => {
		setTotalData({
			...totalData,
			delivery_enhancements: {
				...totalData.delivery_enhancements,
				audience: {
					...totalData.delivery_enhancements.audience,
					partner_lists: FMPartnersSelected
				}
			}
		})
		setSlideAudience(true)
		setShareFMPartner(false)
	}

	return (
		<div className="flex flex-col justify-between h-full">
			<div className="h-[93%]">
				<div className="overflow-y-scroll hide-scroll-bar max-h-[90%] pt-3 mt-[46px]">
					{isLoading ? (
						<div className="flex items-center justify-center w-full h-[400px] py-2 px-1">
							<CircularProgress disableShrink />
						</div>
					) : (
						listPartners.map(item => (
							<BoxPartners
								key={item.id}
								id={`${item.id}`}
								title={item.name}
								itemsSeleted={FMPartnersSelected}
								onClick={() => handleClickPartner(item)}
							/>
						))
					)}
					<div ref={ref}>
						{isFetchingNextPage && <CircularProgress disableShrink />}
					</div>
				</div>
			</div>

			<div className="flex items-center justify-between">
				<Button
					type="button"
					label="Cancel"
					color="Transparent"
					className="!min-w-[130px]"
					onClick={onClickClose}
				/>
				<Button
					label="Save"
					type="button"
					color="Primary"
					className="!min-w-[130px]"
					onClick={onSubmit}
				/>
			</div>
		</div>
	)
}
